<template>
  <div class="mx-auto max-w-rxl sm:px-6 lg:px-8">
    <div class="overflow-hidden bg-white shadow-xl border-solid border border-gray-200 px-7 pt-4 sp:px-3 sp:py-3">
      <div class="w-full text-right">
        <template v-if="!questionListMenu">
          <button
            v-if="onResize"
            class="bg-gray-500 lg:hover:bg-gray-300 active:bg-gray-300 duration-300 text-white py-3 px-4 text-xs my-1 rounded-lg"
            @click="onClickedQuestionListMenu">
            <p class="flex items-center">
              解答リスト
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
            </p>
          </button>
        </template>
      </div>
      <div class="text-lg font-black -ml-4 pb-4">
        <div
          v-if="currentAnswerData.answer_type === 1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="inline h-10 w-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="rgb(239, 68, 68)">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7" />
          </svg>
          <a
            class="text-2xl font-black align-middle text-red-500 whitespace-pre-wrap">
            正解
          </a>
        </div>
        <div v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="inline h-10 w-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="rgb(29, 78, 216)">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
          <a
            class="text-2xl font-black align-middle text-blue-700 whitespace-pre-wrap">
            不正解
          </a>
        </div>
      </div>
      <h2 class="text-lg font-black">{{ `第${ questionIndex + 1 }問目` }}</h2>
      <p class="text-md ml-2 mt-2 whitespace-pre-wrap">
        {{ allQuestions[questionIndex]?.question ?? '' }}
      </p>
      <img
        v-if="props.allQuestions[questionIndex].image_path_question"
        class="mx-auto w-96 mt-10"
        :src="imgPathQuestion">
      <h2 class="mt-4 text-lg font-black">
        正答
      </h2>
      <p class="text-md ml-2 mt-2 font-black text-red-500 whitespace-pre-wrap">
        {{ allQuestions[questionIndex]?.correct_answer ?? '' }}
      </p>
      <h2 class="mt-4 text-lg font-black">
        解説
      </h2>
      <p class="text-md ml-2 my-2 whitespace-pre-wrap">
        {{ allQuestions[questionIndex]?.commentary ?? '' }}
      </p>
      <img
        v-if="allQuestions[questionIndex].image_path_commentary"
        class="mx-auto w-96 mt-10"
        :src="imgPathCommentary">
    </div>
    <div
      v-for="(value, key, index) in partialQuestion"
      :key="key"
      :class="props.choicesOrder[questionIndex][index] === 1 ?
        'text-red-500 font-black flex p-6 sp:p-2 sp:text-sm overflow-hidden bg-white border border-gray-200 shadow-xl sm:rounded-none' :
        props.choicesOrder[questionIndex][index] === currentAnswerData.answer_type ?
          'flex font-black p-6 sp:p-2 sp:text-sm overflow-hidden bg-white border border-gray-200 shadow-xl sm:rounded-none':
          'flex p-6 sp:p-2 sp:text-sm overflow-hidden bg-white border border-gray-200 shadow-xl sm:rounded-none'">
      <p>{{ index + 1 }}: {{ value }}</p>
    </div>
    <div class="flex justify-around bg-gray-100 border-solid border border-gray-200 shadow-xl p-6 sp:p-3">
      <button
        v-if="questionIndex"
        class="bg-white duration-300 py-2.5 px-10 rounded-lg sp:text-sm sp:px-7 border border-gray-300"
        @click="onBackQuestion">
        前の問題
      </button>
      <button
        v-if="isLastQuestion"
        class="bg-red-500 lg:hover:bg-red-300 active:bg-red-300 duration-300 text-white py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg"
        @click="$emit('confirmation')">
        終了する
      </button>
      <button
        v-if="!isLastQuestion"
        class="bg-blue-600 lg:hover:bg-blue-400 active:bg-blue-400 duration-300 sp:text-sm sp:px-7 text-white py-2.5 px-10 rounded-lg"
        @click="onNextQuestion">
        次の問題
      </button>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import {
  ref, reactive, computed, watch, onUnmounted,
} from 'vue'
import { storeToRefs } from 'pinia'
import moment from 'moment'
import defineStore from '../../../stores/user-answer-status'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: String,
    default: null,
  },
  choicesOrder: {
    type: Array,
    default: () => [],
  },
  countAnswer: {
    type: Number,
    default: 0,
  },
  questionAnswers: {
    type: Array,
    default: () => [],
  },
  onResize: {
    type: Boolean,
    default: false,
  },
  questionListMenu: {
    type: Boolean,
    default: false,
  },
  questionIndex: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['on-clicked-question-list-menu', 'confirmation', 'plus-index', 'minus-index'])
const onClickedQuestionListMenu = () => emit('on-clicked-question-list-menu')
const currentAnswerData = computed(() => {
  const answers = JSON.parse(localStorage.getItem('answers')) ?? []
  const currentQuestionId = props.allQuestions[props.questionIndex].id
  const answerNull = { answer_type: 6 }
  return answers.find(item => currentQuestionId === item.question_id) ?? answerNull
})

const partialQuestion = computed(() => {
  const choicesArray = []
  props.choicesOrder[props.questionIndex].forEach(element => {
    switch (element) {
      case 1:
        choicesArray.push(props.allQuestions[props.questionIndex].correct_answer)
        break
      case 2:
        choicesArray.push(props.allQuestions[props.questionIndex].dummy_answer1)
        break
      case 3:
        choicesArray.push(props.allQuestions[props.questionIndex].dummy_answer2)
        break
      case 4:
        choicesArray.push(props.allQuestions[props.questionIndex].dummy_answer3)
        break
      case 5:
        choicesArray.push(props.allQuestions[props.questionIndex].dummy_answer4)
        break
      default:
        break
    }
  })

  return {
    answer1: choicesArray[0] ?? '',
    answer2: choicesArray[1] ?? '',
    answer3: choicesArray[2] ?? '',
    answer4: choicesArray[3] ?? '',
    answer5: choicesArray[4] ?? '',
  }
})

const imgPathQuestion = computed(() => `/img/${props.allQuestions[props.questionIndex].image_path_question}`)
const imgPathCommentary = computed(() => `/img/${props.allQuestions[props.questionIndex].image_path_commentary}`)

const clearHistory = () => {
  window.history.pushState(null, null, window.location.href)
  window.addEventListener('popstate', () => {
    window.history.pushState(null, null, window.location.href)
  })
}

const onNextQuestion = () => {
  emit('plus-index')
  clearHistory()
}

const onBackQuestion = () => {
  emit('minus-index')
  clearHistory()
}

const isLastQuestion = computed(() => props.allQuestions[props.allQuestions.length - 1].id === props.allQuestions[props.questionIndex]?.id)

const onEndQuestion = () => {
  emit('confirmation')
  clearHistory()
}
</script>
